module.exports = __webpack_public_path__ + "media/images/lp/industries/solution-02-004d2a86aff99edd49cf36181c12851b.png";